/**
 * Pure formatting helpers shared by the config-versioning preview views.
 *
 * Kept in a non-component module so the view files export only components
 * (satisfies `react-refresh/only-export-components`).
 */

import type { RestoreReport } from '../../api/configVersioningService';

/** Stringify a diff value for display (objects → JSON, null/undefined → em-dash). */
export function formatDiffValue(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'string') return value === '' ? '—' : value;
  if (typeof value === 'number') return String(value);
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  try {
    return JSON.stringify(value);
  } catch {
    return '[valeur non affichable]';
  }
}

/** One-line human summary of a restore report, used in the success toast. */
export function restoreReportSummary(report: RestoreReport): string {
  const restored = String(report.restored.length);
  const skipped = String(report.skipped.length);
  const conflicts = String(report.conflicts.length);
  const plural = (n: number): string => (n > 1 ? 's' : '');
  return (
    `${restored} restauré${plural(report.restored.length)} · ` +
    `${skipped} ignoré${plural(report.skipped.length)} · ` +
    `${conflicts} conflit${plural(report.conflicts.length)}`
  );
}
